// Route: /study-plan/[id] — LEGACY redirect → /courses/[courseId].
//
// «Учебный план» стал «Курсом» (обучающая система, docs/plans/
// LEARNING-SYSTEM-VISION.md): модель та же (курс == study_plans), сменилась
// адресация. Id не меняется — `params.id` уходит в `params.courseId` один в один.
//
// Redirect критичен: id планов живут в письмах, `recommendations.deepLink`,
// уведомлениях и закладках. `replace: true` — чтобы «назад» не возвращал в
// петлю редиректа.

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

// Search легаси-детали плана (?tab/?demo) валидируем прежней схемой, чтобы
// битый URL не падал ДО редиректа. Дальше — `search as never`: контракт
// search принадлежит /courses/$courseId, его `validateSearch` (zod object)
// отбросит незнакомые ключи сам.
const searchSchema = z.object({
	tab: z.enum(["sections", "calendar", "about"]).optional(),
	demo: z.enum(["default", "loading", "empty", "error"]).optional(),
});

export const Route = createFileRoute("/study-plan/$id")({
	validateSearch: tolerantSearch(searchSchema),
	beforeLoad: ({ params, search }) => {
		// `tab` в воркспейсе курса называется `view`, и из трёх легаси-значений
		// соответствие есть только у одного: `calendar` (такой вид у воркспейса
		// есть). `sections` — это вид по умолчанию, `about` эквивалента не имеет.
		// Прежний `search as never` ронял ключ целиком, то есть закладка
		// «календарь плана» открывала обзор курса. Проверено 2026-08-14.
		throw redirect({
			to: "/courses/$courseId",
			params: { courseId: params.id },
			search: search.tab === "calendar" ? { view: "calendar" as const } : {},
			replace: true,
		});
	},
});
